import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import styled from 'styled-components';

export const StyledLabel = styled.label`
  font-size: 13px;
  left: 5px;
  top: -6px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  margin: 5px 0 20px;

  input {
    flex: 0 0 25px;
    font-size: 50px;
  }
`;

export const ErrorText = styled.div`
  color: #ca3121;
  padding: 10px 0;
  font-size: 14px;
`;

const renderField = ({ input, meta, ...rest }) => {
  return (
    <div className="input-row">
      <input type="text" {...input} {...rest} />
      {meta.error && <ErrorText className="error">{meta.error}</ErrorText>}
    </div>
  );
};

renderField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object
};

const Checkbox = ({ label, name, children, ...rest }) => {
  return (
    <StyledLabel>
      <Field name={name} component={'input'} type={'checkbox'} {...rest}>
        {children}
      </Field>
      {label}
    </StyledLabel>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  children: PropTypes.node
};

export default Checkbox;
